function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9328 15.314C10.8828 15.314 7.93277 13.839 5.23277 11.264C1.55777 7.76396 -0.0172336 3.86396 1.58277 2.16396C1.65777 2.08896 1.73277 2.03896 1.83277 1.98896L3.93277 0.813962C4.40777 0.563962 5.00777 0.688962 5.30777 1.11396L6.83277 3.28896C6.98277 3.51396 7.05777 3.78896 7.00777 4.03896C6.95777 4.31396 6.80777 4.53896 6.58277 4.68896L5.65777 5.28896C5.60777 5.31396 5.60777 5.33896 5.60777 5.36396C5.60777 5.38896 5.60777 5.41396 5.63277 5.43896C6.30777 6.43896 8.23277 8.98896 11.2828 10.814C11.3578 10.864 11.4828 10.839 11.5328 10.789L12.1828 9.91396C12.5078 9.46396 13.1328 9.36396 13.6078 9.66396L15.8828 11.114C16.3578 11.414 16.5078 12.014 16.2078 12.489L14.9578 14.489C14.9078 14.589 14.8328 14.664 14.7578 14.714C14.2828 15.139 13.6578 15.314 12.9328 15.314ZM4.45777 1.53896C4.43277 1.53896 4.40777 1.53896 4.35777 1.56396L2.25777 2.73896C2.23277 2.76396 2.23277 2.76396 2.20777 2.76396C1.15777 3.88896 2.35777 7.31396 5.85777 10.639C9.35777 13.964 12.9828 15.114 14.1828 14.089C14.1828 14.089 14.1828 14.089 14.2078 14.064L15.4578 12.064C15.4828 12.014 15.4828 11.939 15.4078 11.889L13.1328 10.439C13.0578 10.389 12.9328 10.414 12.8828 10.464L12.2328 11.339C11.9078 11.764 11.3078 11.889 10.8328 11.614C7.60777 9.68896 5.60777 7.01396 4.90777 5.93896C4.75777 5.71396 4.70777 5.46396 4.75777 5.18896C4.80777 4.93896 4.95777 4.68896 5.18277 4.56396L6.10777 3.93896C6.15777 3.91396 6.15777 3.88896 6.15777 3.86396C6.15777 3.83896 6.15777 3.81396 6.13277 3.76396L4.60777 1.58896C4.58277 1.56396 4.50777 1.53896 4.45777 1.53896Z",
  fill: "#323F4B"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.661194)"
})));
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.63e5b9eba7b6761076cb2696acd8f55a.svg";
export { ForwardRef as ReactComponent };